import { useAuth } from '../context/authContext';
import LoadingState from '../components/LoadingState';
import { Box } from '@chakra-ui/react';

export default function RequireAuth({ children }: { children: React.ReactNode }): React.ReactNode {
  const { isAuthenticated, hydrated } = useAuth();

  if (!hydrated) {
    return (
      <Box
        position='fixed'
        inset={0}
        bg='loadingBg'
        zIndex={1400}
        display='flex'
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        gap={3}
      >
        <LoadingState />
      </Box>
    );
  }

  if (!isAuthenticated) {
    window.location.assign(`/login/?from=/management-console`);
    return null;
  }

  return children;
}
